export enum PushMessageType {
  msg,
  order,
  ticket,
  tslupdate,
  unknown,
}
